import api from 'containers/api'
import { selectToken } from 'containers/authentication/authenticationSlice'
import useDataLoader from 'containers/dataLoader'
import { useSelector } from 'react-redux'
import { IOrganization } from 'types'

const useListClusteringCategories = (organization: IOrganization) => {
  const token = useSelector(selectToken)
  const getClusteringCategories = () => {
    return api.listClusteringCategories({organizationId: organization.id, token})
  }

  return useDataLoader(getClusteringCategories)
}

export default useListClusteringCategories
